import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//

import global from '@/utils/global';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-type-constructor
    path: '',
    // eslint-disable-next-line vue/require-prop-type-constructor
    instId: ''
  },
  data: function data() {
    return {
      breadcrumblist: []
    };
  },
  created: function created() {
    this.getbreadcrumb();
  },
  methods: {
    getbreadcrumb: function getbreadcrumb() {
      var _this = this;
      global.BreadCrumb.forEach(function (element) {
        if (element.key === _this.path) {
          _this.breadcrumblist = element.value;
        }
      });
    },
    pushto: function pushto(path) {
      if (this.instId >= 0) {
        this.$router.push({
          path: path,
          query: {
            instId: this.instId
          }
        });
      } else {
        this.$router.push(path);
      }
    }
  }
};